<script lang="ts" setup>
  import type { User } from '@solfacil/girassol/dist/types/components/headers/types';

  defineProps<{
    user: User;
  }>();
</script>

<template>
  <div class="store-user-info-menu-action">
    <icon-girassol:account-circle class="icon" />
    <div class="info">
      <span class="title">Boas-vindas</span>
      <span class="subtitle">{{ user.completeName }}</span>
    </div>
    <icon-girassol:expand-more class="action" />
  </div>
</template>

<style lang="scss">
  .store-user-info-menu-action {
    @apply flex items-center gap-nano;
    @apply py-4xs px-micro;

    > .icon {
      @apply icon-size-medium;
      @apply text-neutral-low-dark;
    }

    > .info {
      @apply flex flex-col items-start;

      > .title {
        @apply fonts-body-small-regular;
        @apply text-neutral-low-light;
      }

      > .subtitle {
        @apply fonts-body-small-bold;
        @apply text-neutral-low-dark;
      }
    }

    > .action {
      @apply icon-size-small;
      @apply text-neutral-low-medium;
    }
  }
</style>
